import React from "react";

export const LazyBackTestRunsPage = React.lazy(() =>
    import(
        /* webpackChunkName: "BackTestRunsPage" */ "./BacktestRunsPage"
    ).then(x => ({
        default: x.BackTestRunsPage
    }))
);
